"use client";

import { useEffect } from "react";

interface BodyIdSetterProps {
	documentType: string;
}

export default function BodyIdSetter({ documentType }: BodyIdSetterProps) {
	useEffect(() => {
		document.body.id = documentType;

		return () => {
			document.body.id = "";
		};
	}, [documentType]);

	return null;
}
